import { supabase } from './supabase'

/**
 * Get the full public URL for a Supabase Storage file
 * Automatically detects bucket from path prefix
 * @param {string} path - The storage path (e.g., "logos/barangays/fairview.jpg" or "backgrounds/barangays/bg.jpg")
 * @returns {string|null} Full public URL or null if path is empty
 */
export const getStorageUrl = (path) => {
  if (!path) return null

  // If it's already a full URL, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }

  // Determine bucket based on path prefix
  let bucket = 'logos' // default bucket
  let filePath = path

  if (path.startsWith('logos/')) {
    bucket = 'logos'
    filePath = path.replace('logos/', 'barangays/')
  } else if (path.startsWith('backgrounds/')) {
    bucket = 'backgrounds'
    filePath = path.replace('backgrounds/', 'barangays/')
  }

  // Get the public URL from Supabase Storage
  const { data } = supabase.storage.from(bucket).getPublicUrl(filePath)

  return data?.publicUrl || null
}

/**
 * Get full URL for barangay logo
 * @param {string} logoPath - The logo path from database (e.g., "logos/barangays/fairview.jpg")
 * @returns {string|null} Full logo URL
 */
export const getBarangayLogoUrl = (logoPath) => {
  if (!logoPath) return null

  // If it's already a full URL, return as is
  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath
  }

  // Path format: "logos/barangays/fairview.jpg"
  // Remove "logos/" prefix to get "barangays/fairview.jpg"
  const filePath = logoPath.replace('logos/', '')

  const { data } = supabase.storage.from('logos').getPublicUrl(filePath)

  return data?.publicUrl || null
}

/**
 * Get full URL for barangay background image
 * @param {string} backgroundPath - The background path from database (e.g., "backgrounds/barangays/barangay_fairview.jpg")
 * @returns {string|null} Full background URL
 */
export const getBarangayBackgroundUrl = (backgroundPath) => {
  if (!backgroundPath) return null

  // If it's already a full URL, return as is
  if (backgroundPath.startsWith('http://') || backgroundPath.startsWith('https://')) {
    return backgroundPath
  }

  // Path format: "backgrounds/barangays/barangay_fairview.jpg"
  // Remove "backgrounds/" prefix to get "barangays/barangay_fairview.jpg"
  const filePath = backgroundPath.replace('backgrounds/', '')

  const { data } = supabase.storage.from('backgrounds').getPublicUrl(filePath)

  return data?.publicUrl || null
}
